import Phaser from "phaser";
import { BattleScene } from "./game/scenes/BattleScene";
import { BootScene } from "./game/scenes/BootScene";
import { CareerScene } from "./game/scenes/CareerScene";
import { LeaderboardScene } from "./game/scenes/LeaderboardScene";
import { MenuScene } from "./game/scenes/MenuScene";
import { ReplayScene } from "./game/scenes/ReplayScene";
import { ResultScene } from "./game/scenes/ResultScene";
import { ShopScene } from "./game/scenes/ShopScene";
import "./styles.css";

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: "game",
  width: 1280,
  height: 720,
  backgroundColor: "#08070a",
  pixelArt: false,
  roundPixels: false,
  render: {
    antialias: true,
    antialiasGL: true,
    pixelArt: false
  },
  input: {
    activePointers: 3
  },
  scale: {
    // FIT keeps the 1280x720 design ratio and lets the engine scale + centre the
    // canvas uniformly (no distortion, no off-centre drift). The responsive helpers
    // (installLetterboxFit / BattleScene.layoutBattlefield) stay wired but are inert
    // here because gameSize is pinned at 1280x720 (fit scale = 1).
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    expandParent: true,
    // Fullscreen the #game host (not the bare canvas) so the chat DOM overlay, which is
    // appended inside #game, stays visible in fullscreen instead of being left behind.
    fullscreenTarget: "game"
  },
  scene: [BootScene, MenuScene, BattleScene, ResultScene, ReplayScene, CareerScene, ShopScene, LeaderboardScene]
};

const game = new Phaser.Game(config);

// Exposed for debugging/diagnostics in every build (harmless for a client-only game).
(window as Window & { __PHASER_GAME__?: Phaser.Game }).__PHASER_GAME__ = game;

// Boot safety net. On hard/cached reloads the asset load can finish so fast that the scene
// manager's start queue isn't drained on the following frame — BootScene reaches "running" but
// MenuScene never starts, leaving a black screen. processQueue() is what the game loop normally
// calls each frame; nudging it here drains any stuck "start MenuScene" op. It is a no-op once the
// queue is empty, and the watchdog stops the moment a playable scene is up.
{
  let attempts = 0;
  const watch = window.setInterval(() => {
    if (game.scene.isActive("MenuScene") || game.scene.isActive("BattleScene") || attempts++ > 120) {
      window.clearInterval(watch);
      return;
    }
    game.scene.processQueue();
  }, 150);
}

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  });
}
